var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',[_c('v-toolbar',{attrs:{"fixed":"","app":"","floating":""}},[_c('v-toolbar-title',[_c('span',{staticClass:"font-weight-bold green--text darken-2"},[_vm._v(" PROPERSAM")])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }